<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <dropdown
                :value="value"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import mapFilters from '@/utils/map-filters';

export default {
    name: 'calendar-facet-title-text-transform',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Text Casing',
            tailwindDefinitionProp: 'textTransform',
            value: '',
        };
    },

    computed: {
        options() {
            const baseOptions = this.themeObjectValues.map(v => ({ text: this.titleCase(v), value: v }));

            baseOptions.unshift({ text: 'None', value: '' });

            return baseOptions;
        },
    },

    methods: {
        ...mapFilters(['titleCase']),

        onInput(valueNew) {
            let flexClassNew;

            if (valueNew) {
                flexClassNew = this.addFlexClass({ value: valueNew });
            } else {
                this.removeFlexClass();
            }

            this.onOptionChange(flexClassNew);
            this.$emit('input', flexClassNew);
        },

        onSelectedElement() {
            this.value = this.flexClassDefinition.value || '';
        },
    },
};
</script>
